export default __webpack_public_path__ + "static/media/guate.251a790f.pdf";